/** Wording for the "Updating your database" screen (DatabaseUpdateGate). */

/** "1 min 5 s", "45 s". */
export function formatElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const min = Math.floor(total / 60);
  const sec = total % 60;
  return min > 0 ? `${min} min ${sec} s` : `${sec} s`;
}

/** "Step 12 of 49"; "Getting ready" before the step count is known. */
export function stepText(step?: number, stepCount?: number): string {
  if (!stepCount) return 'Getting ready';
  return `Step ${Math.min(Math.max(step ?? 0, 1), stepCount)} of ${stepCount}`;
}
